import { render } from "./trianglePolygon.vue?vue&type=template&id=4e443d49"
import script from "./trianglePolygon.vue?vue&type=script&lang=js"
export * from "./trianglePolygon.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__